module.exports = __webpack_public_path__ + "img/3_ESG_Utmutato_Egyuttmukodes_az_ellatasi_lancban_boritokep.10b89e16.jpeg";